var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      on: {
        click: function($event) {
          return _vm.newSpeciesLogSearch(_vm.species)
        }
      }
    },
    [
      _c(
        "figure",
        [
          _c("q-img", {
            attrs: {
              src: _vm.species.teaser,
              alt: _vm.species.name,
              ratio: "1",
              basic: ""
            }
          }),
          _vm._v(" "),
          _c("figcaption", [_vm._v(_vm._s(_vm.species.name))])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }